import { api } from '@api'
import { Depot, DepotPutPayload } from '@types'

interface UpdateDepotResponse {
  result: Depot
  message: string
}

const updateDepot = async (depotId: number, depotData: DepotPutPayload) => {
  const response = await api.put<UpdateDepotResponse>(`/depots/${depotId}`, { depot: depotData })

  return response.data.message
}

export const DepotsApi = { updateDepot }
